import styled from 'styled-components';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

const getHorizontalPositionStyle = (value: number) => {
  if (value > 50) {
    return { right: `calc(100% - ${value}%)` };
  }

  return { left: `${value}%` };
};

export type PlacementOptions = 'top' | 'bottom';

interface LegendWrapperProps {
  percentage: number;
  placement: PlacementOptions;
}

export const LegendWrapper = styled(Box)<LegendWrapperProps>(props => {
  const { percentage, placement } = props;

  return {
    position: 'absolute',
    ...(placement === 'top' ? { top: 0 } : { bottom: 0 }),
    ...getHorizontalPositionStyle(percentage),
  };
});

export const ArrowUp = styled.div(({ theme }) => ({
  width: 0,
  height: 0,
  borderLeft: '8px solid transparent',
  borderRight: '8px solid transparent',
  borderBottom: `12px solid ${theme.colors.gray['600']}`,
}));

export const ArrowDown = styled.div(({ theme }) => ({
  width: 0,
  height: 0,
  borderLeft: '8px solid transparent',
  borderRight: '8px solid transparent',
  borderTop: `12px solid ${theme.colors.gray['600']}`,
}));
